import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { Component, Vue } from "vue-property-decorator";

dayjs.extend(utc);

@Component
export default class DateUtils extends Vue {
	toShortDate(date: Date): string {
		if (localStorage.getItem("useLocal") != "true") {
			return (
				dayjs(date)
					.utc()
					.format("MMM D YYYY") + " UTC"
			);
		} else {
			return dayjs(date).format("MMM D YYYY");
		}
	}

	toLongDate(date: Date): string {
		if (localStorage.getItem("useLocal") != "true") {
			return (
				dayjs(date)
					.utc()
					.format("MMM D YYYY h:mm a") + " UTC"
			);
		} else {
			return dayjs(date).format("MMM D YYYY h:mm a");
		}
	}

	toMonthShortDate(date: Date): string {
		if (localStorage.getItem("useLocal") != "true") {
			return (
				dayjs(date)
					.utc()
					.format("MMM D YYYY") + " UTC"
			);
		} else {
			return dayjs(date).format("MMM D YYYY");
		}
	}

	calculateDaysLeft(expirationDate: string | Date): number {
		return dayjs(expirationDate).diff(new Date(), "day");
	}

	dateIsBetweenBounds(
		expirationDate: Date,
		closerDaysBound: number,
		furtherDaysBound: number
	): boolean {
		let furtherBoundDate: Date = dayjs(expirationDate)
			.subtract(furtherDaysBound, "day")
			.toDate();
		let closerBoundDate: Date = dayjs(expirationDate)
			.subtract(closerDaysBound, "day")
			.toDate();
		let today = new Date();

		return furtherBoundDate < today && today < closerBoundDate;
	}

	getMonthName(date: Date): string {
		return dayjs(date).format("MMMM");
	}

	getMonthNumber(date: Date): number {
		return Number.parseInt(dayjs(date).format("M"));
	}

	addDays(date: Date, numDays: number): Date {
		return dayjs(date)
			.add(numDays, "day")
			.toDate();
	}
}
